import React, { useEffect, useState, useRef } from 'react';
import { ProductGrid } from './shop/ProductGrid';
import { ProductCard } from './shop/ProductCard';
import { Cart } from './shop/Cart';
import { ShoppingCartIcon, FilterIcon, GridIcon, ListIcon } from 'lucide-react';
export const Shop = ({
  onCursorChange
}) => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [cart, setCart] = useState([]);
  const [viewMode, setViewMode] = useState('grid');
  const [filter, setFilter] = useState('all');
  const [sortBy, setSortBy] = useState('featured');
  const [activeCategory, setActiveCategory] = useState('all');
  const productsContainerRef = useRef(null);
  // Print-on-demand merchandise products
  const products = [{
    id: 1,
    name: 'Biohazard Mug',
    price: 24.99,
    category: 'mug',
    image: 'https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1760&q=80',
    description: 'Ceramic mug with biohazard symbol design. Microwave and dishwasher safe.',
    available: true,
    featured: true,
    url: '#shop'
  }, {
    id: 2,
    name: 'Neural Hoodie',
    price: 59.99,
    category: 'apparel',
    image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
    description: 'Premium pullover hoodie with neural network pattern. 80% cotton, 20% polyester.',
    available: true,
    featured: true,
    url: '#shop'
  }, {
    id: 3,
    name: 'Organism Sweater',
    price: 49.99,
    category: 'apparel',
    image: 'https://images.unsplash.com/photo-1580331451062-99ff207845a3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
    description: 'Cozy crewneck sweater with abstract organism design. Soft and comfortable fabric.',
    available: true,
    featured: false,
    url: '#shop'
  }, {
    id: 4,
    name: 'Hydro Bottle',
    price: 34.99,
    category: 'bottle',
    image: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
    description: 'Insulated stainless steel water bottle. Keeps drinks cold for 24 hours, hot for 12 hours.',
    available: true,
    featured: true,
    url: '#shop'
  }, {
    id: 5,
    name: 'DNA Keychain',
    price: 14.99,
    category: 'accessory',
    image: 'https://images.unsplash.com/photo-1611490616683-813145093263?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1780&q=80',
    description: 'Metal keychain with DNA helix design. Durable and lightweight.',
    available: true,
    featured: false,
    url: '#shop'
  }, {
    id: 6,
    name: 'Cyber Sticker Pack',
    price: 12.99,
    category: 'sticker',
    image: 'https://images.unsplash.com/photo-1620288627223-53302f4e8c74?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1964&q=80',
    description: 'Set of 10 cyberpunk-themed vinyl stickers. Waterproof and UV resistant.',
    available: true,
    featured: true,
    url: '#shop'
  }, {
    id: 7,
    name: 'Quantum Tote Bag',
    price: 29.99,
    category: 'accessory',
    image: 'https://images.unsplash.com/photo-1622560480654-d96214fdc887?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1888&q=80',
    description: 'Canvas tote bag with quantum pattern print. Sturdy and spacious.',
    available: false,
    featured: false,
    url: '#shop'
  }, {
    id: 8,
    name: 'Lab Phone Case',
    price: 24.99,
    category: 'accessory',
    image: 'https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1889&q=80',
    description: 'Protective phone case with laboratory glassware design. Available for various models.',
    available: true,
    featured: false,
    url: '#shop'
  }];
  // Add to cart function
  const addToCart = product => {
    const existingItem = cart.find(item => item.id === product.id);
    if (existingItem) {
      setCart(cart.map(item => item.id === product.id ? {
        ...item,
        quantity: item.quantity + 1
      } : item));
    } else {
      setCart([...cart, {
        ...product,
        quantity: 1
      }]);
    }
    // Show cart when item is added
    setIsCartOpen(true);
  };
  // Remove from cart function
  const removeFromCart = productId => {
    setCart(cart.filter(item => item.id !== productId));
  };
  // Update quantity function
  const updateQuantity = (productId, newQuantity) => {
    if (newQuantity < 1) return;
    setCart(cart.map(item => item.id === productId ? {
      ...item,
      quantity: newQuantity
    } : item));
  };
  // Filter products based on category
  const filteredProducts = filter === 'all' ? products : products.filter(product => product.category === filter);
  // Sort products
  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (sortBy === 'featured') return (b.featured ? 1 : 0) - (a.featured ? 1 : 0);
    if (sortBy === 'price-asc') return a.price - b.price;
    if (sortBy === 'price-desc') return b.price - a.price;
    if (sortBy === 'name') return a.name.localeCompare(b.name);
    return 0;
  });
  // Calculate cart total
  const cartTotal = cart.reduce((total, item) => total + item.price * item.quantity, 0);
  // Categories for filter
  const categories = [{
    id: 'all',
    name: 'ALL ITEMS'
  }, {
    id: 'apparel',
    name: 'APPAREL'
  }, {
    id: 'mug',
    name: 'MUGS'
  }, {
    id: 'bottle',
    name: 'BOTTLES'
  }, {
    id: 'accessory',
    name: 'ACCESSORIES'
  }, {
    id: 'sticker',
    name: 'STICKERS'
  }];
  // Scroll products container horizontally
  const handleScroll = direction => {
    if (productsContainerRef.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      productsContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <section id="shop" className="w-full py-24 bg-[#030508] relative" data-id="element-1175">
      <style jsx global data-id="element-1176">{`
        .tech-grid {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image:
            linear-gradient(
              to right,
              rgba(111, 248, 240, 0.05) 1px,
              transparent 1px
            ),
            linear-gradient(
              to bottom,
              rgba(111, 248, 240, 0.05) 1px,
              transparent 1px
            );
          background-size: 20px 20px;
          opacity: 0.2;
          pointer-events: none;
        }
        .category-button {
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }
        .category-button::before {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          height: 1px;
          width: 0;
          background: #6ff8f0;
          transition: width 0.3s ease;
        }
        .category-button:hover::before,
        .category-button.active::before {
          width: 100%;
        }
        .category-button.active {
          color: #6ff8f0;
        }
        .sort-select {
          background: rgba(10, 16, 24, 0.7);
          border: 1px solid rgba(111, 248, 240, 0.2);
          color: #a0c0e0;
          font-family: 'JetBrains Mono', monospace;
          font-size: 0.8rem;
          padding: 0.5rem 1rem;
          border-radius: 4px;
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%236ff8f0' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 0.5rem center;
          background-size: 1rem;
          padding-right: 2rem;
        }
        .cart-button {
          position: fixed;
          bottom: 80px;
          right: 20px;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: rgba(10, 16, 24, 0.8);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(111, 248, 240, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #6ff8f0;
          box-shadow: 0 0 15px rgba(111, 248, 240, 0.15);
          transition: all 0.3s ease;
          z-index: 100;
        }
        .cart-button:hover {
          box-shadow: 0 0 20px rgba(111, 248, 240, 0.3);
          transform: translateY(-2px);
        }
        .cart-count {
          position: absolute;
          top: -5px;
          right: -5px;
          background: #e64cff;
          color: #030508;
          font-size: 0.7rem;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          box-shadow: 0 0 10px rgba(230, 76, 255, 0.5);
        }
        .view-toggle-button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 4px;
          background: rgba(10, 16, 24, 0.7);
          border: 1px solid rgba(111, 248, 240, 0.2);
          color: #a0c0e0;
          transition: all 0.3s ease;
        }
        .view-toggle-button.active {
          color: #6ff8f0;
          border-color: rgba(111, 248, 240, 0.5);
          background: rgba(111, 248, 240, 0.1);
        }
        .view-toggle-button:hover {
          border-color: rgba(111, 248, 240, 0.5);
        }
        .products-scroll-container {
          overflow-x: auto;
          scrollbar-width: thin;
          scrollbar-color: rgba(111, 248, 240, 0.3) rgba(10, 16, 24, 0.5);
          scroll-behavior: smooth;
          padding: 1rem 0;
          -webkit-overflow-scrolling: touch;
        }
        .products-scroll-container::-webkit-scrollbar {
          height: 6px;
        }
        .products-scroll-container::-webkit-scrollbar-track {
          background: rgba(10, 16, 24, 0.5);
          border-radius: 3px;
        }
        .products-scroll-container::-webkit-scrollbar-thumb {
          background-color: rgba(111, 248, 240, 0.3);
          border-radius: 3px;
        }
        .scroll-button {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(10, 16, 24, 0.8);
          backdrop-filter: blur(4px);
          border: 1px solid rgba(111, 248, 240, 0.2);
          color: #6ff8f0;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 5;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .scroll-button:hover {
          background: rgba(111, 248, 240, 0.2);
        }
        .scroll-button.left {
          left: 10px;
        }
        .scroll-button.right {
          right: 10px;
        }
        @media (max-width: 640px) {
          .scroll-button {
            display: none;
          }
        }
      `}</style>

      {/* Background effects */}
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-1177"></div>
      <div className="tech-grid" data-id="element-1178"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-1179">
        <div className="max-w-6xl mx-auto" data-id="element-1180">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-gradient font-heading animate-fade-in-up text-center" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1181">
            PRODUCTS
          </h2>
          <p className="text-[#a0c0e0] mb-8 max-w-2xl font-mono animate-fade-in-up mx-auto text-center" style={{
          animationDelay: '0.2s'
        }} onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1182">
            Custom print-on-demand merchandise featuring unique biological
            distortion designs. Express yourself with our exclusive collection
            of apparel and accessories.
          </p>

          {/* Shop controls */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 animate-fade-in-up" style={{
          animationDelay: '0.3s'
        }} data-id="element-1183">
            {/* Categories */}
            <div className="flex flex-wrap gap-4 mb-4 md:mb-0 mx-auto md:mx-0" data-id="element-1184">
              {categories.map(category => <button key={category.id} className={`category-button font-mono text-xs ${activeCategory === category.id ? 'active' : 'text-[#a0c0e0]'}`} onClick={() => {
              setFilter(category.id);
              setActiveCategory(category.id);
            }} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} data-id="element-1185">
                  {category.name}
                </button>)}
            </div>
            {/* Sort and view controls */}
            <div className="flex items-center gap-4 mx-auto md:mx-0" data-id="element-1186">
              <div className="flex items-center" data-id="element-1187">
                <FilterIcon size={14} className="text-[#a0c0e0] mr-2" data-id="element-1188" />
                <select className="sort-select" value={sortBy} onChange={e => setSortBy(e.target.value)} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} data-id="element-1189">
                  <option value="featured" data-id="element-1190">FEATURED</option>
                  <option value="price-asc" data-id="element-1191">PRICE: LOW TO HIGH</option>
                  <option value="price-desc" data-id="element-1192">PRICE: HIGH TO LOW</option>
                  <option value="name" data-id="element-1193">NAME</option>
                </select>
              </div>
              <div className="flex gap-2" data-id="element-1194">
                <button className={`view-toggle-button ${viewMode === 'grid' ? 'active' : ''}`} onClick={() => setViewMode('grid')} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} aria-label="Grid view" data-id="element-1195">
                  <GridIcon size={16} data-id="element-1196" />
                </button>
                <button className={`view-toggle-button ${viewMode === 'list' ? 'active' : ''}`} onClick={() => setViewMode('list')} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} aria-label="List view" data-id="element-1197">
                  <ListIcon size={16} data-id="element-1198" />
                </button>
              </div>
            </div>
          </div>

          {/* Products row with horizontal scrolling */}
          <div className="relative" data-id="element-1199">
            <button className="scroll-button left" onClick={() => handleScroll('left')} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} aria-label="Scroll left" data-id="element-1200">
              &lt;
            </button>
            <div className="products-scroll-container" ref={productsContainerRef} data-id="element-1201">
              <div className={`flex ${viewMode === 'grid' ? 'gap-4' : 'flex-col gap-4'}`} data-id="element-1202">
                {sortedProducts.map(product => <div key={product.id} className={viewMode === 'grid' ? 'min-w-[280px] max-w-[280px]' : 'w-full'} data-id="element-1203">
                    <ProductCard product={product} viewMode={viewMode} onAddToCart={addToCart} onCursorChange={onCursorChange} data-id="element-1204" />
                  </div>)}
                {sortedProducts.length === 0 && <div className="py-12 text-center w-full" data-id="element-1205">
                    <p className="text-[#a0c0e0] font-mono" data-id="element-1206">
                      No products match your criteria.
                    </p>
                  </div>}
              </div>
            </div>
            <button className="scroll-button right" onClick={() => handleScroll('right')} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} aria-label="Scroll right" data-id="element-1207">
              &gt;
            </button>
          </div>

          {/* Cart button */}
          <button className="cart-button" onClick={() => setIsCartOpen(true)} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} aria-label="Open cart" data-id="element-1208">
            <ShoppingCartIcon size={20} data-id="element-1209" />
            {cart.length > 0 && <span className="cart-count" data-id="element-1210">
                {cart.reduce((total, item) => total + item.quantity, 0)}
              </span>}
          </button>

          {/* Cart component */}
          <Cart isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} cart={cart} onRemoveItem={removeFromCart} onUpdateQuantity={updateQuantity} total={cartTotal} onCursorChange={onCursorChange} data-id="element-1211" />
        </div>
      </div>
    </section>;
};